import { useEffect } from "react";

/**
 * usePageMeta({ title, description, canonical, ogImage, ogType })
 * or legacy: usePageMeta(title, description)
 */
export default function usePageMeta(titleOrOpts, description) {
  useEffect(() => {
    const opts = typeof titleOrOpts === "string"
      ? { title: titleOrOpts, description }
      : titleOrOpts || {};

    if (opts.title) document.title = opts.title;

    const setMeta = (attr, value, contentVal) => {
      if (!contentVal) return;
      let el = document.querySelector(`meta[${attr}="${value}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
      el.setAttribute("content", contentVal);
    };

    setMeta("name", "description", opts.description);
    setMeta("property", "og:title", opts.ogTitle || opts.title);
    setMeta("property", "og:description", opts.ogDescription || opts.description);
    setMeta("property", "og:type", opts.ogType || "website");
    setMeta("property", "og:image", opts.ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", opts.ogTitle || opts.title);
    setMeta("name", "twitter:description", opts.ogDescription || opts.description);
    setMeta("name", "twitter:image", opts.ogImage);

    if (opts.canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", opts.canonical);
    }
  }, [JSON.stringify(titleOrOpts), description]);
}
